<div class="card">
  <div class="card-header">
    <h5 class="title">User Signature</h5>
  </div>

  <div class="card-body">
    <ng-container *ngIf="user">
      <p class="small" *ngIf="!user.signatureFile">Please click below and choose either a JPG or PNG image to be used as a signature.</p>

      <img *ngIf="user.signatureFile" style="max-width: 80%" [src]="imageUrl" />

      <button class="btn btn-block btn-success" (click)="file.click()">Upload Signature</button>
      <div class="form-group">
        <input #file type="file" class="form-control" name="signatureFile" id="signatureFile" accept="image/jpg, image/jpeg, image/png" (change)="onFileChange($event)" />
      </div>
    </ng-container>
  </div>
</div>

<p-dialog header="Uploading..." [(visible)]="showSpinner" modal="true" [closable]="false" [resizable]="false" [style]="{'min-height': '50px'}" appendTo="body" [baseZIndex]="500">
  <div style="width: 50px; margin: 0 auto">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }" [strokeWidth]="4"></p-progressSpinner>
  </div>
</p-dialog>
